var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1668 14.3792C17.4951 14.2347 16.9637 14.5466 16.4932 14.8189C16.0114 15.0996 15.0951 15.8429 14.57 15.6526C11.8811 14.5455 9.35213 12.192 8.25739 9.49237C8.06444 8.95598 8.80424 8.03391 9.08283 7.54637C9.35316 7.07443 9.65858 6.53803 9.51928 5.8613C9.3934 5.25317 7.76522 3.18139 7.18947 2.61484C6.80977 2.24061 6.42078 2.03479 6.02147 2.00152C4.5202 1.93707 2.84352 3.94024 2.54945 4.41947C1.81274 5.44133 1.81687 6.80103 2.56183 8.44973C4.35717 12.8781 11.1475 19.5613 15.5925 21.4241C16.4128 21.8077 17.1629 22 17.8366 22C18.496 22 19.0831 21.816 19.5876 21.4511C19.9684 21.2318 22.0536 19.4719 21.9989 17.9302C21.9659 17.5373 21.7606 17.1444 21.3912 16.7639C20.8289 16.1828 18.7704 14.506 18.1668 14.3792Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.83a45351.svg";
export { ForwardRef as ReactComponent };